import { Col } from "antd";
import React, { useCallback } from "react";
import { ChatbotMessages, ChatbotVisitor } from "@components";

const ChatRight = ({
  chatInput,
  setChatInput,
  conversation,
  handleSendMessage,
}) => {
  const handleChatInputChange = useCallback((content) => {
    setChatInput((prevInput) => ({ ...prevInput, message: content }));
  }, []);

  return (
    <>
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={12}
        xl={14}
        style={{
          background: "#ffffff",
        }}
      >
        <ChatbotMessages
          chatInput={chatInput}
          handleChatInputChange={handleChatInputChange}
          handleSendMessage={handleSendMessage}
          conversation={conversation}
        />
      </Col>

      {/* Right Chatbot Visitor */}
      <Col
        xs={24}
        sm={24}
        md={6}
        lg={6}
        xl={5}
        style={{
          background: "#ffffff",
        }}
      >
        <ChatbotVisitor />
      </Col>
    </>
  );
};

export default ChatRight;
